import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=02cb7dc2&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"
import style0 from "./FaqView.vue?vue&type=style&index=0&id=02cb7dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb7dc2",
  null
  
)

export default component.exports